import React from 'react'
import { ReactComponent as ClearIcon } from '../../images/icons/icn_delete_copy.svg'
import { ClassNamesProps } from 'types/utilities'
import cx from 'classnames'
import styles from './styles/filterField.module.scss'
import i18n from 'constants/strings'

type ClassKeys = 'input' | 'wrapper' | 'clearBtn'

interface Props extends ClassNamesProps<ClassKeys> {
  value: string
  onValueChange: (value: string) => void
  onClear?: () => void
  inputProps: Omit<
    React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    'value' | 'onChange' | 'className'
  >
}

const FilterField = ({ value, onValueChange, onClear, classNames, inputProps = {} }: Props) => {
  return (
    <div className={cx(styles.wrapper, classNames?.wrapper)}>
      <input
        type='text'
        value={value}
        onChange={e => onValueChange(e.target.value)}
        className={cx(styles.commonTextInput, styles.input, classNames?.input)}
        {...inputProps}
      />
      {value && onClear && (
        <button
          aria-label={i18n.t('strCommonUI.button.clearTextField')}
          className={cx(styles.clearBtn, classNames?.clearBtn)}
          onClick={onClear}
        >
          <ClearIcon aria-hidden />
        </button>
      )}
    </div>
  )
}

export default FilterField
